import React from 'react'
import { Formik, Form } from 'formik';
import * as Yup from 'yup'
import LoadingButton from '@mui/lab/LoadingButton';
import { Alert, Button, Typography } from '@mui/material';
import TextField from '../Common/Fields/TextField';


export default function BackToPopVehicleHoldForm({ fetchedData, isLoading, handleSubmit, setModal, btnLabel = 'Raise Docket' }) {
    // const { problemsData, problemsIsLoading } = useLCOProblemsList();
    const validate = Yup.object({

        // vehicle1_pop_km: Yup.string().required('KM is required.'),
    })
    return (
        <Formik
            initialValues={{
                vehicle2_pop_km: fetchedData?.vehicle1_pop_km ?? 0,
                vehicle2_pop_km: fetchedData?.vehicle2_pop_km ?? 0,
            }}
            validationSchema={validate}
            onSubmit={handleSubmit}
        >
            {formik => (

                <Form>
                    <div className='row'>
                        {fetchedData?.vehicle1 && fetchedData?.vehicle1_to_pop  && <div>
                            <div className="d-flex justify-content-between mb-2">
                                <div>
                                    <p className="text-dark m-0"><strong>Vehicle 1:</strong> {fetchedData?.get_vehicles?.vehicle1_name} (<small>Start:{fetchedData.vehicle1_start_km}</small> <small>End:{fetchedData.vehicle1_end_km}</small>)</p>
                                </div>
                                <div>
                                    <p className="text-dark m-0">{fetchedData.vehicle1_end_km - fetchedData.vehicle1_start_km} KM</p>
                                </div>
                            </div>
                            <TextField label='End to POP KM *' type="number" name='vehicle1_pop_km' placeholder='End to POP KM' sx={{ mt: 2 }} />
                        </div>}
                        {fetchedData?.vehicle2 && fetchedData?.vehicle2_to_pop && <div>
                            <div className="d-flex justify-content-between mb-2 mt-2">
                                <div>
                                    <p className="text-dark m-0"><strong>Vehicle 2:</strong> {fetchedData?.get_vehicles?.vehicle2_name} (<small>Start:{fetchedData?.vehicle2_start_km}</small> <small>End:{fetchedData?.vehicle2_end_km}</small>)</p>
                                </div>
                                <div>
                                    <p className="text-dark m-0">{fetchedData.vehicle2_end_km - fetchedData.vehicle2_start_km} KM</p>
                                </div>
                            </div>
                            <TextField label='End to POP KM *' type="number" name='vehicle2_pop_km' placeholder='End to POP KM' sx={{ mt: 2 }} />
                        </div>}
                       
                        {/* <div className="col-md-12 mb-4">

                            <TextField label='End KM *' type="number" name='vehicle2_pop_km' placeholder='End KM' sx={{ mt: 2 }} />
                            <TextField label='End KM *' type="number" name='vehicle3_pop_km' placeholder='End KM' sx={{ mt: 2 }} />
                        </div> */}
                        {/* {console.log(formik.values.problem)} */}
                        {/* {formik.submitCount >= 1 && formik.errors && Object.entries(formik.errors).map(([key, value]) =>
                            <Alert severity="error" sx={{ mt: 1, mb: 1 }} key={key}>{value}</Alert>
                        )} */}
                    </div>
                    <LoadingButton
                        loading={isLoading}
                        type="submit"
                        variant="contained"
                        disableElevation
                        disabled={formik.values.vehicle1_pop_km <= 0 && formik.values.vehicle2_pop_km <= 0}
                    >
                        {btnLabel}
                    </LoadingButton>
                    <Button variant="outlined" sx={{ ml: 1 }} disableElevation onClick={() => setModal(false)}>Close</Button>
                </Form>
            )}
        </Formik>
    )
}
